/// <amd-module name="Wit/Common/BulkUpdateUtils/TagUtils" />
import { IWorkItemFieldChange } from "Wit/Common/BulkUpdateUtils/BulkUpdateInterfaces";
import { CoreField } from "Wit/Common/Generated/Constants";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { isEditable } from "Wit/WorkItemModel/WorkItem/FieldUtils";

/**
 * Will see if the change is a tag add/remove change. If so, will edit tags accordingly
 *
 * @return Positive integer equal to attempted tags to add, negative integer equal to attempted tags to remove, or 0 for no change
 */
export function processTagsChanges(workItem: IWorkItem, change: IWorkItemFieldChange) {
    const tagField = workItem.getFieldById(CoreField.Tags);
    if (tagField && isEditable(tagField)) {
        const existingTags = splitAndTrimTags(workItem.getFieldValueById(CoreField.Tags));
        const tagChanges = splitAndTrimTags(change.value);
        const tags =
            change.fieldName === AddTagsPseudoRefName
                ? [...new Set([...existingTags, ...tagChanges]).values()]
                : change.fieldName === RemoveTagsPseudoRefName
                ? existingTags.filter(t => tagChanges.indexOf(t) < 0)
                : undefined;

        if (tags) {
            workItem.setFieldValueById(CoreField.Tags, formatTags(tags));
        }
    }
}

export const AddTagsPseudoRefName = "System.Tags-Add";
export const RemoveTagsPseudoRefName = "System.Tags-Remove";
export const TagSplittingSeparator: RegExp = /[,;]/;

export function splitAndTrimTags(tagsText: string): string[] {
    if (!tagsText) {
        return [];
    }

    const tags: string[] = tagsText.split(TagSplittingSeparator);
    const trimmedTags: string[] = [];
    for (const tag of tags) {
        const trimmedTag = tag.trim();
        if (trimmedTag) {
            trimmedTags.push(trimmedTag);
        }
    }

    return trimmedTags;
}

export function formatTags(tags: string[]): string {
    return tags.join("; ");
}
